(function() {
    'use strict';

    angular
        .module('app.campaignInfluencersManagePage')
        .controller('viewCampaignInfoCtrl', ['$scope', '$rootScope', '$sanitize', '$modalInstance', '$modal', 'viewCampaignInfoService', 'campaignConsts', 'commonConsts',
            function ($scope, $rootScope, $sanitize, $modalInstance, $modal, viewCampaignInfoService, campaignConsts, commonConsts) {
                $scope.forOneInfluencer = true;
                $scope.viewedByInfluencer = $rootScope.currentUser.role.accessLevel === 'influencer';
                $scope.reviewCampaignTitle = 'Campaign invitation';
                $scope.campaignTypeConsts = angular.copy(campaignConsts.Types);
                $scope.keywordTypeConsts = angular.copy(commonConsts.KeywordTypes);

                // Get params from parent
                $scope.campaignId = angular.copy($scope.paramsFromParent.campaignId);
                $scope.campaignInfluencerId = angular.copy($scope.paramsFromParent.campaignInfluencerId);
                $scope.influencerId = angular.copy($scope.paramsFromParent.influencerId);
                $scope.afterReviewCampaignAccepted = angular.copy($scope.paramsFromParent.afterReviewCampaignAccepted);
                $scope.afterReviewCampaignRejected = angular.copy($scope.paramsFromParent.afterReviewCampaignRejected);

                init();

                ////////////////

                function init() {
                    getCampaign();
                    getCampaignTermsForInfluencer();
                    getCampaignFiles();
                }

                function getCampaign() {
                    viewCampaignInfoService.getCampaign($scope.campaignId, true).then(function (result) {
                        var campaign = result.data;
                        $scope.campaignName = campaign.name;
                        $scope.campaignBrief = campaign.brief;
                        $scope.additionalInfo = { value: campaign.additionalInfo };

                        $scope.campaignType = $rootScope.definitions.campaignTypes.filter(function(type) {
                            return type.value === campaign.projectType;
                        })[0];

                        getMentions(campaign.projectKeywords);
                        getAdvertiser(campaign.company_id);
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function getMentions(campaignKeywords) {
                    $scope.keywordList = [];
                    $scope.urlList = [];
                    $scope.hashtagList = [];
                    campaignKeywords.forEach(function(campaignKeyword) {
                        var mention = {
                            name: campaignKeyword.keyword.keyword,
                            type: campaignKeyword.keyword.keywordType.id,
                        }

                        switch (mention.type) {
                            case $scope.keywordTypeConsts.KEYWORD:
                                $scope.keywordList.push(mention);
                                break;
                            case $scope.keywordTypeConsts.URL:
                                $scope.urlList.push(mention);
                                break;
                            case $scope.keywordTypeConsts.HASH_TAG:
                                $scope.hashtagList.push(mention);
                                break;
                            default:
                                break;
                        }
                    });
                }

                function getAdvertiser(advertiserId) {
                    viewCampaignInfoService.getAdvertiser(advertiserId, false).then(function (result) {
                        var advertiserName = result.data.name;
                        $scope.reviewCampaignTitle+= ' from ' + advertiserName;
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function getCampaignTermsForInfluencer() {
                    viewCampaignInfoService.getCampaignTermsForInfluencer($scope.campaignId, $scope.campaignInfluencerId, false).then(function (result) {
                        var campaignTerms = result.data;

                        $scope.selectedTermList = campaignTerms.map(function (campaignTerm) {
                            var term = campaignTerm.term;
                            term.params = JSON.parse(campaignTerm.params);

                            return term;
                        }).sort(function(termA, termB) {
                            return termA.contractSeq < termB.contractSeq ? -1 : (termA.contractSeq > termB.contractSeq ? 1 : 0);
                        });
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                function isImageFile(contentType) {
                    var imageRegex = new RegExp(/image\/.*/g);
                    return imageRegex.test(contentType);
                }

                function getThumbnailSrc(contentType, fileId) {
                    if (isImageFile(contentType)) {
                        return viewCampaignInfoService.getUploadedFileUrl(fileId);
                    }

                    return '/images/attach.png';
                }

                function getCampaignFiles() {
                    $scope.fileList = [];
                    viewCampaignInfoService.getCampaignFiles($scope.campaignId, false) // loader = false
                        .then(function(res){
                            var campaignFiles = res.data;

                            campaignFiles.forEach(function(campaignFile) {
                                var file = {
                                    id: campaignFile.id,
                                    fileId: campaignFile.fileId,
                                    contentType: campaignFile.contentType,
                                    name: campaignFile.fileName,
                                    action: 'none',
                                    downloadLink: viewCampaignInfoService.getUploadedFileUrl(campaignFile.fileId)
                                };

                                file.thumbnail = getThumbnailSrc(file.contentType, file.fileId);

                                $scope.fileList.push(file);
                            });
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }

                $scope.parseTermParamValue = function(term) {
                    var paramsIsObject = term.params !== null && typeof term.params === 'object'
                    if (!term.hasParams || !paramsIsObject) {
                        return term.summary;
                    } else {
                        var display = term.summary;

                        Object.keys(term.params).forEach(function(paramName) {
                            display = display.replace('{{' + paramName + '}}', term.params[paramName].value);
                        });

                        return display;
                    }
                }

                function isFunction(functionToCheck) {
                    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
                }

                /**
                 * Accept button
                 */
            	$scope.onReviewCampaignAccept = function() {
                    var params = {
                        campaignInfluencerId: $scope.campaignInfluencerId,
                    }

                    viewCampaignInfoService.acceptCampaign(params, true).then(function (result) {
                        if (isFunction($scope.afterReviewCampaignAccepted)) {
                            $scope.afterReviewCampaignAccepted();
                        }
                        $scope.onReviewCampaignCancel();
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                /**
                 * Reject button
                 */
            	$scope.onReviewCampaignReject = function() {
                    var params = {
                        campaignInfluencerId: $scope.campaignInfluencerId,
                        accessLevel: $rootScope.currentUser.role.accessLevel
                    }

                    viewCampaignInfoService.rejectCampaign(params, true).then(function (result) {
                        if (isFunction($scope.afterReviewCampaignRejected)) {
                            $scope.afterReviewCampaignRejected();
                        }
                        $scope.onReviewCampaignCancel();
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
                }

                /**
                 * Cancel and Close buttons
                 */
            	$scope.onReviewCampaignCancel = function() {
            		$modalInstance.close();
                }

                $scope.viewContract = function () {
                    var viewContractInfoModalScope = $rootScope.$new();
                    viewContractInfoModalScope.paramsFromParent = {
                        campaignId: $scope.campaignId,
                        influencerId: $scope.influencerId,
                        campaignInfluencerId: $scope.campaignInfluencerId,
                        afterReviewCampaignAccepted: $scope.afterReviewCampaignAccepted
                    };

                    var viewContractInfoModalInstance = $modal.open({
                        scope: viewContractInfoModalScope,
                        templateUrl: 'app/campaign/campaignViewContract/campaignViewContract.html?app_v=deployDate',
                        controller: 'campaignViewContractCtrl',
                    });

                    $scope.viewContractInfoModalInstance = viewContractInfoModalInstance;
                }
            }
        ]);
})();